module.exports = __webpack_public_path__ + "static/media/17.b49bf70a.jpg";